/**
 * Mock API Interceptor
 *
 * Intercetta le chiamate axios e restituisce mock JSON se disponibili.
 * Si attiva solo se VUE_APP_USE_MOCKS === 'true'
 */

import axios from 'axios';
import { findMockFile } from './mockRegistry';

const USE_MOCKS = process.env.VUE_APP_USE_MOCKS === 'true';

if (USE_MOCKS) {
  console.log('[Mock API] Mock mode enabled');

  // Cache per i mock già caricati
  const mockCache = {};

  // Carica tutti i mock disponibili nella cartella data/
  const mockContext = require.context('./data', false, /\.json$/);
  mockContext.keys().forEach((key) => {
    const filename = key.replace('./', '');
    mockCache[filename] = mockContext(key);
  });

  console.log('[Mock API] Mock files loaded:', Object.keys(mockCache));

  // Interceptor request
  axios.interceptors.request.use(
    async (config) => {
      const url = config.url;

      // Estrai il path dall'URL (rimuovi base URL se presente)
      let path = url;
      const baseUrl = process.env.VUE_APP_API_BASE_URL;
      if (baseUrl && url.startsWith(baseUrl)) {
        path = url.substring(baseUrl.length);
      }

      const mockFile = findMockFile(path);

      if (mockFile && mockCache[mockFile]) {
        console.log(`[Mock API] Intercepting: ${path} -> ${mockFile}`);

        // Marca la request per restituire il mock nella response
        config._mockData = mockCache[mockFile];
        config._mockFile = mockFile;

        // Usa un adapter custom per cortocircuitare la request
        config.adapter = () => {
          return Promise.resolve({
            data: config._mockData,
            status: 200,
            statusText: 'OK (mocked)',
            headers: {},
            config: config,
          });
        };
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Interceptor response (per logging)
  axios.interceptors.response.use(
    (response) => {
      if (response.config._mockFile) {
        console.log(`[Mock API] Response mocked: ${response.config._mockFile}`);
      }
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
} else {
  console.log('[Mock API] Mock mode disabled');
}

export default USE_MOCKS;
